import { render } from "./CommentFlagOptions.vue?vue&type=template&id=f2eee53a"
import script from "./CommentFlagOptions.vue?vue&type=script&lang=js"
export * from "./CommentFlagOptions.vue?vue&type=script&lang=js"
script.render = render

export default script